import React, { useContext } from 'react';
import { AppContext } from 'App.context.js';
import styles from './ModalInfoCreateText.styles';

export default function InvoiceTemplateGuide() {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const tags = {
    hotel: ['{hotelName}', '{hotelAddress}', '{hotelCountry}'],
    supplier: [
      '{supplierName}',
      '{supplierAddress}',
      '{supplierCity}',
      '{supplierPostalCode}',
      '{supplierCountry}',
      '{supplierFiscalId}',
    ],
    payment: ['{paymentMethod}', '{paymentTransactionId}', '{paymentCreditCard}'],
    itemsAndTaxes: {
      items: ['{date}', '{description}', '{debit}', '{credit}'],
      taxes: ['{taxDescription}', '{taxRate}', '{taxAmount}'],
    },
    invoice: [
      '{roomNumber}',
      '{arrivalDate}',
      '{departureDate}',
      '{billNumber}',
      '{invoiceDate}',
      '{reservationNumber}',
      '{idGuest}',
      '{guestName}',
      '{fullName}',
      '{grossAmount}',
      '{netAmount}',
      '{totalTaxes}',
      '{cashierId}',
      '{folioType}',
      '{invoiceCurrency}',
      '{paxNumber}',
      '{externalReference}',
      '{balance}',
      '{taxSummaries}',
    ],
    merchantInfo: [
      '{transactionId}',
      '{approvalCode}',
      '{approvalAmount}',
      '{terminalId}',
      '{numberOfMerchant}',
      '{creditCard}',
      '{sellByDate}',
      '{captureMethod}',
      '{transactionAmount}',
    ],
  };

  return (
    <div style={styles.guideContainer}>
      <h1 style={styles.guideTitle}>
        {translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.titleGuide')}
      </h1>
      <p style={styles.guideSubtitle}>
        {translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.subTitleGuide')}
      </p>

      <div style={styles.tagsGrid}>
        {Object.entries(tags).map(([title, tagList]) => {
          if (title === 'itemsAndTaxes') {
            return (
              <div key={title} style={styles.tagCard}>
                <h3 style={styles.tagCardTitle}>🔹 Items</h3>
                <div style={styles.tagList}>
                  {tagList.items.map(tag => (
                    <span key={tag} style={styles.tagPill}>
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 style={styles.tagCardTitle}>🔹 Taxes</h3>
                <div style={styles.tagList}>
                  {tagList.taxes.map(tag => (
                    <span key={tag} style={styles.tagPill}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            );
          }

          return (
            <div key={title} style={styles.tagCard}>
              <h3 style={styles.tagCardTitle}>
                🔹 {title.charAt(0).toUpperCase() + title.slice(1)}
              </h3>
              <div style={styles.tagList}>
                {tagList.map(tag => (
                  <span key={tag} style={styles.tagPill}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>
          {translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.titleLoop')}
        </h2>
        <p>{translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.subTitleLoop')}</p>
        <p>{translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.textLoop')}</p>
        <h3 style={styles.sectionTitle}>
          {translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.invoiceLoop')}
        </h3>
        <pre style={styles.codeBlock}>
          {`{items}
        {date} {description} {debit} {credit}
{endItems}`}
        </pre>
      </div>

      <div style={styles.section}>
        <h3 style={styles.sectionTitle}>
          {translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.taxesLoop')}
        </h3>
        <pre style={styles.codeBlock}>
          {`{taxes}
  {taxDescription} {taxRate} {taxAmount}
{endTaxes}`}
        </pre>
      </div>

      <div style={styles.noteBox}>
        <h2 style={styles.noteTitle}>
          {translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.titleNotes')}
        </h2>
        <ul style={styles.noteList}>
          <li>{translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.text1Notes')}</li>
          <li>{translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.text2Notes')} </li>
          <li>{translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.text3Notes')}</li>
          <li>{translate('hbxProducts.invoiceAutomationFiles.infoCreateTemplate.text4Notes')}</li>
        </ul>
      </div>
    </div>
  );
}
